import React, { useEffect, useState, useRef } from 'react'
import {
  CModal,
  CModalHeader,
  CModalBody,
  CModalFooter,
  CTable,
  CTableHead,
  CTableRow,
  CTableHeaderCell,
  CTableBody,
  CTableDataCell,
  CButton,
} from '@coreui/react-pro'
import RoundService from 'src/service/RoundService'
import moment from 'moment'

const PreviewRoundTable = ({ visible, onClose }) => {
  const [rounds, setRounds] = useState([])
  const [loading, setLoading] = useState(false)
  const tableContainerRef = useRef(null)

  useEffect(() => {
    if (visible) {
      fetchRounds()
    }
  }, [visible])

  const fetchRounds = async () => {
    setLoading(true)
    try {
      const res = await RoundService.getRoundPreview()
      if (res && res.status === 200) {
        setRounds(res.data || [])
      } else {
        setRounds(res.data || [])
      }
    } catch (e) {
      console.error('Error fetching rounds', e)
      setRounds([])
    } finally {
      setLoading(false)
      // reset scroll to top after content loads
      setTimeout(() => {
        if (tableContainerRef && tableContainerRef.current) {
          tableContainerRef.current.scrollTop = 0
        }
      }, 50)
    }
  }

  return (
    <CModal visible={visible} onClose={onClose} size="lg">
      <CModalHeader>
        <h5 className="modal-title">Rounds</h5>
      </CModalHeader>

      <CModalBody>
        <div
          ref={tableContainerRef}
          style={rounds.length > 30 ? { maxHeight: '360px', overflowY: 'auto' } : {}}
        >
          <CTable bordered small>
            <CTableHead>
              <CTableRow>
                <CTableHeaderCell>Round</CTableHeaderCell>
                <CTableHeaderCell>Start Date</CTableHeaderCell>
                <CTableHeaderCell>Start Time</CTableHeaderCell>
                <CTableHeaderCell>End Date</CTableHeaderCell>
                <CTableHeaderCell>End Time</CTableHeaderCell>
              </CTableRow>
            </CTableHead>

            <CTableBody>
              {loading ? (
                <CTableRow>
                  <CTableDataCell colSpan={6}>Loading...</CTableDataCell>
                </CTableRow>
              ) : rounds.length === 0 ? (
                <CTableRow>
                  <CTableDataCell colSpan={6}>No records found</CTableDataCell>
                </CTableRow>
              ) : (
                rounds.map((item, index) => (
                  <CTableRow key={item.id || index}>
                    <CTableDataCell>{item.round}</CTableDataCell>
                    <CTableDataCell>
                      {item.start_date ? moment(item.start_date).format('D.MM.YYYY') : ''}
                    </CTableDataCell>
                    <CTableDataCell>
                      {item.start_date ? moment(item.start_date).format('h:mm A') : ''}
                    </CTableDataCell>
                    <CTableDataCell>
                      {item.end_date ? moment(item.end_date).format('D.MM.YYYY') : ''}
                    </CTableDataCell>
                    <CTableDataCell>
                      {item.end_date ? moment(item.end_date).format('h:mm A') : ''}
                    </CTableDataCell>
                  </CTableRow>
                ))
              )}
            </CTableBody>
          </CTable>
        </div>
      </CModalBody>

      <CModalFooter>
        <CButton color="secondary" onClick={onClose}>
          Close
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

export default PreviewRoundTable
